module.exports = __webpack_public_path__ + "img/outer-edit.2d9ebc37.png";